import { UIKey } from '../services/storage/ui-key-value';

export function uiKeyToParamKey(key: UIKey): string {
  let paramKey = '';
  switch (key) {
    case UIKey.UTM_SOURCE:
      paramKey = 'utm_source';
      break;
    case UIKey.UTM_MEDIUM:
      paramKey = 'utm_medium';
      break;
    case UIKey.UTM_CAMPAIGN:
      paramKey = 'utm_campaign';
      break;
    case UIKey.UTM_TERM:
      paramKey = 'utm_term';
      break;
    case UIKey.GCLID:
      paramKey = 'gclid';
      break;
    case UIKey.FBCLID:
      paramKey = 'fbclid';
      break;
    case UIKey.LI_FAT_ID:
      paramKey = 'li_fat_id';
      break;
    default:
      paramKey = '';
  }

  return paramKey;
}
